import { Box } from '@mui/material';
import { TabPanel } from '@mui/lab';
import React from 'react';
import ChargesJK from 'views/orders/charges-accounting/charges-jk/charges-jk';

export const ChargesJKTabContent = () => {
  return (
    <TabPanel value="J-K" style={{ padding: '16px', marginTop: '1rem' }}>
      <Box>
        <ChargesJK showHeaderAndContainer={false} />
      </Box>
    </TabPanel>
  );
};
